const state = {
    user: {
        username: 'test-user-1',
        email: 'test-user@example.com'
    },
    cars: [
        {
           "id": 1,
           "name":"Example wishlist 1",
           "items": {}
        },
        {
         "id": 2,
         "name":"Example wishlist 2",
         "items": {}
        }
    ],
    "makes": []
  };
  
  export default state;